import axios from "axios";

axios.interceptors.request.use((config) => {
  const url = (config.url || "").toLowerCase();


  const skipDbKey =
    url.includes("/login/") ||
    url.includes("/check-email/") ||
    url.includes("/forgotpassword/") ||
    url.includes("/resetpassword/") ||
    url.includes("/send-email");

  if (!skipDbKey) {
    const userStr = sessionStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      const dbKey = user?.db_key;
      if (dbKey) config.headers["X-DB-KEY"] = dbKey;
    }
  }

  return config;
});
